import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  constructor(private router : Router) { 
    console.log("Global Service constructor");
  }

  pushToNewPage(pageClassName : any, navParamToPassed? : any){
    const navigationExtras: NavigationExtras = {
      skipLocationChange : true,
      queryParams:{
        navParamsData : navParamToPassed
      }
    };
    this.router.navigate([pageClassName], navigationExtras);
  }
  checkIfDataVaild(dataToBeValidated : any) :boolean {
    return(dataToBeValidated != null && dataToBeValidated != undefined && dataToBeValidated !='') ? true : false;
  }
}
